module.exports = __webpack_public_path__ + "static/media/pikto_piosenki.d64954bd.png";